import { render } from "./CategoryTitle.vue?vue&type=template&id=f3f4a082&scoped=true"
const script = {}

import "./CategoryTitle.vue?vue&type=style&index=0&id=f3f4a082&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3f4a082"]])

export default __exports__